import { ExternalUrls } from '@app/shared/config/externalUrls';
import { ExternalHttpClient } from '@app/shared/utils/http';
import { ExternalRepository as IExternalRepository } from './externalRepository.type';
import { RedirectLoginResponse } from '@app/shared/models/RedirectLogin.response';

export class ExternalRepository implements IExternalRepository {
  constructor() {}

  public async getRedirectLogin(): Promise<RedirectLoginResponse> {
    const result = await ExternalHttpClient.getInstance().get(`${ExternalUrls.LOGIN}`);
    return result?.data;
  }
}
